// features/drive/components/Explorer/Explorer.js

import React from 'react';

import useDrive from '../../hooks/useDrive';

import Breadcrumb from '../Breadcrumb/Breadcrumb';
import DriveTable from '../Table/DriveTable';
import GridView from '../Grid/GridView';

import { ExplorerWrapper, ExplorerHeader, ExplorerBody } from './Explorer.styles';

const Explorer = () => {
  const { view } = useDrive();

  return (
    <ExplorerWrapper>
      <ExplorerHeader>
        <Breadcrumb />
      </ExplorerHeader>

      <ExplorerBody>{view === 'table' ? <DriveTable /> : <GridView />}</ExplorerBody>
    </ExplorerWrapper>
  );
};

export default Explorer;
